<template>
  <RevMediaViewer
    :alternative-button-label="i18n(translations.alternativeController)"
    :alternative-next="i18n(translations.alternativeNext)"
    :alternative-previous="i18n(translations.alternativePrevious)"
    :close-button-label="i18n(translations.alternativeClose)"
    :current-index
    current-index-id="gallery-media-viewer"
    data-test="product-page-media-viewer"
    :name="MODAL_NAMES.MEDIA_VIEWER"
    :thumbnails="mediaViewerThumbnails"
    @close="emit('update:currentIndex', 0)"
  >
    <template #default="{ imgClassNames = '' } = {}">
      <RevIllustration
        v-for="(image, index) in images"
        :key="image.id"
        :alt="image.alt"
        :class="imgClassNames"
        :height="1200"
        :loading="index === 0 ? 'eager' : 'lazy'"
        :src="image.src"
        :width="1200"
      />
    </template>
  </RevMediaViewer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevMediaViewer } from '@ds/components/MediaViewer'

import { MODAL_NAMES } from '~/scopes/product/constants'
import translations from '~/scopes/product-core/components/presentationals/GalleryNew/GalleryNew.translations'
import type { ProductDetailPageGalleryImage } from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/ProductDetailPageGallery.types'

const props = defineProps<{
  images: ProductDetailPageGalleryImage[]
  currentIndex: number
}>()

const emit = defineEmits<{
  (e: 'update:currentIndex', value: number): void
}>()

const i18n = useI18n()

const mediaViewerThumbnails = computed(() =>
  props.images.map((image) => ({
    ...image,
    height: 1200,
    width: 1200,
  })),
)
</script>
